import styled from "styled-components";
import {Button, message, Space} from "antd";
import {useDispatch, useSelector, useStore} from "@/components/resume/redux/hooks";
import config, {autoOnePageLevels} from "@/const/config";
import withComponent from "@/hoc/withComponent";
import paginationSlice from "@/components/resume/redux/services/paginationSlice";
import useResumeDetailInstance from "@/pages/ResumeDetail/hooks/useResumeDetailInstance";

const ContainerStyled = styled.div`
    position: relative;
    /* height: 48px; */
    background: #FFFFFF;
    /* border: 1px solid #ECECEC; */
    display: flex;
    align-items: center;
    padding: 0 16px;
    /* width: 794px; */
    justify-content: space-between;
    z-index: 99;
`
const Container2Styled = styled.div`
  flex-shrink: 0;

`
const CellStyled = styled.div`
  display: flex;
  align-items: center;
`

const ModuleItemStyled = styled.div`
    display: flex;
    align-items: center;
    margin-right: 14px;
    > div {
        display: flex;
        align-items: center;
        margin-right: 4px;
    }
    &:hover {
        cursor: pointer;
        color: #11BBA6;
        svg {
            circle {
                fill: #11BBA6;
            }
            path {
                fill: ${props => props.unActivePath ? '' : '#11BBA6'};
            }
        }
    }
`

const icon1 = <div dangerouslySetInnerHTML={{ __html: `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="简历详情编辑页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="图标选中样式" transform="translate(-51.000000, -68.000000)" fill="#6E727C" fill-rule="nonzero">
            <g id="模块管理" transform="translate(51.000000, 68.000000)">
                <path d="M9.35574809,10.6422291 L3.77280473,10.6432294 C3.11672137,10.6432294 2.57657261,11.1396481 2.5074687,11.7773656 L2.5,11.9160526 L2.5,16.227186 C2.5,16.8832733 2.99640623,17.4234187 3.63411863,17.4925221 L3.77280473,17.4999907 L8.08393814,17.4999907 C8.42151543,17.4999907 8.74526192,17.3658954 8.9839597,17.1272007 C9.18856033,16.9226027 9.31631212,16.6555207 9.34863711,16.3708054 L9.35676136,16.227186 L9.35574809,10.6422291 Z M16.227186,10.6432294 L10.6422444,10.6422291 L10.6432479,16.227186 C10.6432479,16.8832733 11.1396541,17.4234187 11.7773665,17.4925221 L11.9160526,17.4999907 L16.227186,17.4999907 C16.8832733,17.4999907 17.4234187,17.0035845 17.4925221,16.3658721 L17.4999907,16.227186 L17.4999907,11.9160526 C17.4999907,11.5784753 17.3658954,11.2547288 17.1272007,11.0160311 C16.9226027,10.8114304 16.6555207,10.6836786 16.3708054,10.6513536 L16.227186,10.6432294 Z M8.08393814,2.5 L3.77280473,2.5 C3.11671746,2.5 2.57657209,2.99640623 2.50746864,3.63411863 L2.5,3.77280473 L2.5,8.08393814 C2.5,8.42151543 2.63409538,8.74526192 2.87279008,8.9839597 C3.07738807,9.18856033 3.34447008,9.31631212 3.62918532,9.34863711 L3.77280473,9.35676136 L9.35574809,9.35573275 L9.35674286,3.77280473 C9.35674286,3.16358084 8.92871913,2.65432725 8.35698463,2.52935694 L8.22262423,2.50746864 L8.08393814,2.5 Z M14.0716286,2.5 C12.1781913,2.5 10.6432571,4.03493417 10.6432571,5.92837143 C10.6432571,7.82180869 12.1781913,9.35674286 14.0716286,9.35674286 C15.9650658,9.35674286 17.5,7.82180869 17.5,5.92837143 C17.5,4.03493417 15.9650658,2.5 14.0716286,2.5 Z" id="形状"></path>
            </g>
        </g>
    </g>
</svg>
`}} />
const icon2 = <div dangerouslySetInnerHTML={{ __html: `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="简历详情编辑页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="图标选中样式" transform="translate(-161.000000, -68.000000)" fill="#6E727C" fill-rule="nonzero">
            <g id="编组-7备份" transform="translate(51.000000, 68.000000)">
                <g id="模块管理备份" transform="translate(110.000000, 0.000000)">
                    <path d="M11.7316487,3.75 L11.68134,4.3254059 C11.6090213,5.15549966 10.8984107,5.80322432 10.0651726,5.80322434 C9.21935742,5.80322434 8.52446832,5.16807684 8.44900525,4.32226162 L8.39869655,3.75 L2.5,3.75 L2.5,9.75874685 L4.68842899,9.75874685 L4.68842899,15.6134233 C4.68842899,16.6541848 5.53424422,17.5 6.57500571,17.5 L13.5584839,17.5 C14.5992454,17.5 15.4450606,16.6541848 15.4450606,15.6134233 L15.4450606,9.75874685 L17.6334896,9.75874685 L17.6334896,3.75 L11.7316487,3.75 Z" id="形状"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
`}} />
const icon3 = <div dangerouslySetInnerHTML={{ __html: `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="简历详情编辑页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="图标选中样式" transform="translate(-271.000000, -68.000000)">
            <g id="编组-7备份" transform="translate(51.000000, 68.000000)">
                <g id="模块管理备份-2" transform="translate(220.000000, 0.000000)">
                    <circle id="椭圆形" fill="#6E727C" cx="10" cy="10" r="8.75"></circle>
                    <path d="M7.06818182,10.1625 L7.0675,12.54875 L12.13625,12.54875 L12.1363636,11.0855256 L14.7751953,13.1965909 L12.1363636,15.3076562 L12.13625,13.84375 L6.42045454,13.8443182 C6.14222018,13.8443182 5.90495981,13.6688877 5.81325072,13.4226039 L5.78316302,13.3130207 L5.77272727,13.1965909 L5.77272727,10.1625 L7.06818182,10.1625 Z M7.86363636,4.6875 L7.8625,6.15015621 L13.5795455,6.15083803 C13.8577798,6.15083803 14.0950402,6.32626854 14.1867493,6.57255227 L14.216837,6.6821355 L14.2272727,6.7985653 L14.2272727,9.83265621 L12.9318182,9.83265621 L12.93125,7.44515621 L7.8625,7.44515621 L7.86363636,8.90963061 L5.22480474,6.7985653 L7.86363636,4.6875 Z" id="形状" fill="#FFFFFF" fill-rule="nonzero"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
`}} />
const icon4 = <div dangerouslySetInnerHTML={{ __html: `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="简历详情编辑页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="图标选中样式" transform="translate(-381.000000, -68.000000)" fill="#6E727C" fill-rule="nonzero">
            <g id="编组-7备份" transform="translate(51.000000, 68.000000)">
                <g id="模块管理备份-3" transform="translate(330.000000, 0.000000)">
                    <path d="M11.25,16.25 L11.25,2.5 L17.5,2.5 L17.5,5 L12.5,5 L12.5,15 L17.5,15 L17.5,17.5 L11.25,17.5 L11.25,16.25 Z M7.5,15 L7.5,5 L2.5,5 L2.5,2.5 L8.75,2.5 L8.75,17.5 L2.5,17.5 L2.5,15 L7.5,15 Z M5,10.625 L2.5,10.625 L2.5,9.375 L5,9.375 L5,8.125 L6.875,10 L5,11.875 L5,10.625 Z M15,10.625 L17.5,10.625 L17.5,9.375 L15,9.375 L15,8.125 L13.125,10 L15,11.875 L15,10.625 Z" id="形状备份" transform="translate(10.000000, 10.000000) rotate(-90.000000) translate(-10.000000, -10.000000) "></path>
                </g>
            </g>
        </g>
    </g>
</svg>
`}} />
export default withComponent((props) => {
    const {onClickModule, setThemeVisible, setChangeTemplateVisible, setImportModalVisible} = props;
    const dispatch = useDispatch();
    const openAutoPagination = useSelector((state) => state.pagination.openAutoPagination);
    const openHintPagination = useSelector((state) => state.pagination.openHintPagination);
    const openAutoOnePage = useSelector((state) => state.pagination.openAutoOnePage);

    const onClickHintPagination = () => {
        dispatch(paginationSlice.actions.switchHintPagination())

    }
    const onClickAutoPagination = () => {
        dispatch(paginationSlice.actions.switchAutoPagination())
    }
    const onClickAutoOnePage = () => {
        dispatch(paginationSlice.actions.switchAutoOnePage())
    }

    return <Container2Styled>
        <ContainerStyled>
            <CellStyled>
                <Space>
                    <ModuleItemStyled onClick={onClickModule}>{icon1}模块管理</ModuleItemStyled>
                    <ModuleItemStyled onClick={() => setThemeVisible(true)}>{icon2}主题设置</ModuleItemStyled>
                    <ModuleItemStyled unActivePath={true} onClick={() => setChangeTemplateVisible(true)}>{icon3}更换模板</ModuleItemStyled>
                    <ModuleItemStyled onClick={onClickAutoPagination}>{icon4}{openAutoPagination ? '取消分页' : '自动分页'}</ModuleItemStyled>
                </Space>
            </CellStyled>
            {/* <CellStyled>
                <Space>
                    <Button onClick={onClickHintPagination}>{openHintPagination ? '取消提示' : '分页提示'}</Button>
                    <Button onClick={onClickAutoPagination}>{openAutoPagination ? '取消分页' : '自动分页'}</Button>
                    <Button onClick={onClickAutoOnePage}>{openAutoOnePage ? '取消一页' : '智能一页'}</Button>
                    <Button onClick={() => setImportModalVisible(true)}>导入简历</Button>
                </Space>
            </CellStyled> */}
        </ContainerStyled>
    </Container2Styled>
})
